import React from 'react'
import styled from '@emotion/styled'
import { bool, node, string } from 'prop-types'
import { makeImgResizerUrl, makeImgResizeBlurUrl } from '@jelly/utils'

//IMPORT COMPONENTS
import { Hero } from '../Hero'

// Styled Components via Emotion
const SectionWrapper = styled.section`
	height: ${({ height }) => height};
	position: relative;
	width: 100%;
`
const HeroImg = styled.div`
	background-color: ${({ theme }) => theme.colors.tertiary};
	background-size: cover;
	background-position: ${({ bgPosition }) => bgPosition || 'top center'};
	background-repeat: no-repeat;
	height: inherit;
	width: 100%;

	${({ theme }) => theme.MQ.L} {
		&.lazyloaded {
			background-image: url(${({ background }) => background});
		}
	}

	${({ theme }) => theme.MQ.MAX} {
		background-position: ${({ maxBgPosition }) => maxBgPosition || '0 50%'};
	}
`
const HeroImgOverlay = styled.div`
	background: ${({ overlayColor }) => overlayColor};
	opacity: 0;
	height: inherit;
	position: absolute;
	top: 0;
	width: 100%;

	${({ theme }) => theme.MQ.L} {
		opacity: ${({ isBlurred, opacity }) => (isBlurred ? '.6' : opacity)};
	}
`

HeroContext.propTypes = {
	align: string,
	background: string,
	bgPosition: string,
	children: node,
	height: string,
	isBlurred: bool,
	maxBgPosition: string,
	overlayColor: string,
	overlayOpacity: string,
}

/**
 * This Component is the HeroContext
 * This pulls together the Hamburger Menu, Hero and Navigation components
 * This is where we determine whether or not a Solo Search panel should slide out
 *
 * We set the background here, so the overlay doesn't impact the Hero component text
 * We also have the option to flip any image via CSS
 * (intend for it to be refactored)
 */
export function HeroContext({
	align,
	background,
	bgPosition,
	children,
	height,
	isBlurred,
	maxBgPosition,
	overlayColor = '#000',
	overlayOpacity = '0.2',
}) {
	const baseBgImgOptions = {
		src: background,
		method: 'w',
		w: '1400-jpg:50',
	}

	const backgroundUrl = isBlurred
		? makeImgResizeBlurUrl({ ...baseBgImgOptions, sigma: 8, radius: 8 })
		: makeImgResizerUrl(baseBgImgOptions)

	return (
		<SectionWrapper height={height}>
			<HeroImg
				background={backgroundUrl}
				className="lazyload"
				height={height}
				bgPosition={bgPosition}
				maxBgPosition={maxBgPosition}
			/>
			<HeroImgOverlay
				height={height}
				overlayColor={overlayColor}
				opacity={overlayOpacity}
				isBlurred={isBlurred}
			/>
			<Hero align={align} content={children} />
		</SectionWrapper>
	)
}
